import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './messages';
import { PromotionalBanner } from '../components/promotional-banner';
import { useGlobalModalLaunchContext } from '../contexts/modal-context/global-modal-context';

/**
 * A promotional banner component that displays information about a gated feature
 * and provides an upgrade button. This component is typically used to promote
 * premium features that require a plan upgrade.
 * @param {object} props - The component props
 * @param {string} [props.className] - Additional CSS class name for styling
 * @param {React.ReactNode} [props.featureName] - The name of the feature being promoted,
 *                                         defaults to a generic feature name message
 * @returns {React.ReactElement} A promotional banner with feature information and optional upgrade button
 */
export const FeatureGatedPromotionalBanner = ({ className, featureName = <FormattedMessage {...messages.defaultFeatureName} /> }) => {
  const { openManageSubscriptionDrawer } = useGlobalModalLaunchContext();

  return (
    <PromotionalBanner
      className={className}
      promotionalHeaderMessage={<FormattedMessage {...messages.promotionalBannerTitle} values={{ featureName }} />}
      promotionalSubheaderMessage={messages.promotionalBannerMessage}
    >
      <Button onClick={openManageSubscriptionDrawer} theme={THEME_CONSTANTS.promotional}>
        <FormattedMessage {...messages.upgradeButton} />
      </Button>
    </PromotionalBanner>
  );
};
